
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4f1t8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61aa8de0ca8d98b5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $61aa8de0ca8d98b5$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Tous les sites',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Fermer',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(actuellement indisponible)',
    'navigation.global-shortcuts.sites': "Sites\xa0{productName}",
    'navigation.global-shortcuts.apps.teams': 'French Teams'
};

});


//# sourceMappingURL=fr.4af6484e.js.map
